import { render, staticRenderFns } from "./HealthRecord.vue?vue&type=template&id=4d0ec0a0"
import script from "./HealthRecord.vue?vue&type=script&lang=js"
export * from "./HealthRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports